import axiosInstance from "../helpers/axiosInstance";

const BASE_URL = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/shipping-packages`;

export const fetchShippingPackages = async (params = {}) => {
    const res = await axiosInstance.get(BASE_URL, { params });
    return res.data;
};

export const createShippingPackage = async (data) => {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
};

export const updateShippingPackage = async (id, data) => {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
};

export const deleteShippingPackage = async (id, data = {}) => {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`, { data });
    return res.data;
};

export const restoreShippingPackage = async (id, params = {}) => {
    const res = await axiosInstance.patch(`${BASE_URL}/${id}/restore`, null, { params });
    return res.data;
};

export const fetchShippingPackageHistory = async (id, params = {}) => {
    const res = await axiosInstance.get(`${BASE_URL}/${id}/history`, { params });
    return res.data;
};

export const calculateVolumetricWeight = async (params) => {
    const res = await axiosInstance.get(`${BASE_URL}/calculate-volumetric-weight`, { params });
    return res.data;
};
